import { IOrderFlawed } from 'my-poppies-b2b-types';

import { timestampMockHelpers } from '@/utils/timestampMockHelpers';

export const dummyDataOrdersFlawed: IOrderFlawed[] = [
  {
    userRole: 'EVA',
    erpId: 'some-erp-id-234293049',
    id: 'first-flawed-order',
    sender: 'SOME_SENDER',
    priority: 'HIGH',
    createdBy: 'BERNHARD',
    createdAt: timestampMockHelpers.now,
    updatedBy: 'SAM',
    updatedAt: timestampMockHelpers.tenMinutesLater,
    customerId: 'customer-0',
    customerPretty: 'Customer Name Pretty',
    status: 'FLAWED',
    positions: [
      { positionId: 'kleine-kapseln-40g', amount: 123 },
      { positionId: 'große-kapseln-120g', amount: 14 },
    ],
  },
  {
    userRole: 'EVA',
    id: 'second-flawed-order',
    erpId: 'some-erp-id-12309234',
    sender: 'SOME_SENDER',
    priority: 'LOW',
    createdAt: timestampMockHelpers.now,
    createdBy: 'BERNHARD',
    updatedAt: timestampMockHelpers.tenMinutesLater,
    updatedBy: 'SAM',
    customerId: 'customer-1',
    customerPretty: 'Customer Name Pretty',
    status: 'FLAWED',
    positions: [{ positionId: 'palette-800-100', amount: 17 }],
    history: [
      {
        shippingStatus: 'CANCELLED',
        shippingStatusPretty: { de: 'Abgebrochen', en: 'Cancelled' },
        notes: { en: 'Some english Notes that René might have added', de: 'Ein paar deutsche Bemerkungen von René' },
        location: 'Hamburg',
        startedAt: 15928394,
      },
    ],
  },
];
